import React from 'react'
import Component from 'ui/pages/shared/Root'

const Root: React.FC = () => <Component />

export default Root
